import { axiosGet, axiosPost } from "./apiClient";

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/adminusers`;

const getUsers = async ({
    limit = 10,
    page = 0,
    status = null,
    userType = "",
    roleId = "",
    sortModel = [],
    search = "",
}) => {
    return await axiosGet(`${BASE_URL}/get`, {
        limit,
        page,
        status,
        userType,
        roleId,
        search,
        sort: JSON.stringify(sortModel || []),
    });
};
const updateStatus = async (params) => {
    return await axiosPost(`${BASE_URL}/status/`, { ...params });
};

const getStatusLog = async (params) => {
    return await axiosPost(`${BASE_URL}/status/log`, { ...params });
};
const createUser = async (roleData) => {
    return await axiosPost(`${BASE_URL}/create`, roleData);
};
const UserDetails = async ({ id }) => {
    return await axiosGet(`${BASE_URL}/detail`, { id });
};

const assignRole = async (params) => {
    return await axiosPost(`${BASE_URL}/assignrole/`, { ...params });
};
const changePassword = async (params) => {
    return await axiosPost(`${BASE_URL}/change-password`, params);
};


const userApi = {
    getUsers,
    getStatusLog,
    createUser,
    updateStatus,
    UserDetails,
    assignRole,
    changePassword
}

export default userApi;